import type { ColumnDef } from "@tanstack/react-table";
import type { ApInvoice } from "@/accounts-payable/types";

export const invoiceNumberCol: ColumnDef<ApInvoice> = {
  accessorKey: "invoice_number",
  header: "Invoice #",
  meta: { size: "130px" },
  cell: ({ row }) => <span>{row.original.invoice_number}</span>,
};
